import React from "react";
import { useLinkTo } from "@react-navigation/native";
import Live from "./Live";

export default function LiveScreen(props) {
  const linkTo = useLinkTo();

  return <Live linkTo={linkTo} navigation={props.navigation} />;
}
